var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner ai-task-create" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "section task-form",
          attrs: {
            model: _vm.form,
            "label-width": "100px",
            "label-position": "left",
            size: "mini"
          }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c("el-col", { attrs: { span: 24 } }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("div", { staticClass: "section-title__bar" }),
                  _c("div", [
                    _c("div", { staticClass: "section-title__main" }, [
                      _vm._v("新建对账任务")
                    ]),
                    _c("div", { staticClass: "section-title__desc" }, [
                      _vm._v("填写基础信息并上传供应商账单后发起对账任务。")
                    ])
                  ])
                ])
              ])
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择供应商", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "320px" },
                          attrs: {
                            filterable: "",
                            remote: "",
                            clearable: "",
                            "reserve-keyword": "",
                            placeholder: "请输入供应商名称搜索",
                            "remote-method": _vm.remoteSupplierMethod,
                            loading: _vm.supplierLoading
                          },
                          on: { change: _vm.handleSupplierChange },
                          model: {
                            value: _vm.form.supplierId,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "supplierId", $$v)
                            },
                            expression: "form.supplierId"
                          }
                        },
                        _vm._l(_vm.supplierOptions, function(item) {
                          return _c("el-option", {
                            key: item.supplierId,
                            attrs: {
                              label: item.supplierName,
                              value: item.supplierId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "开始日期", required: "" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "请选择开始日期"
                        },
                        model: {
                          value: _vm.form.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "startDate", $$v)
                          },
                          expression: "form.startDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "结束日期", required: "" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          placeholder: "请选择结束日期"
                        },
                        model: {
                          value: _vm.form.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "endDate", $$v)
                          },
                          expression: "form.endDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "账单类型", required: "" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "bill-type-group",
                          model: {
                            value: _vm.form.billType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "billType", $$v)
                            },
                            expression: "form.billType"
                          }
                        },
                        _vm._l(_vm.billTypeOptions, function(item) {
                          return _c(
                            "el-radio-button",
                            { key: item.code, attrs: { label: item.code } },
                            [_vm._v(" " + _vm._s(item.label) + " ")]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传账单", required: "" } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-area",
                          attrs: {
                            drag: "",
                            action: "#",
                            "auto-upload": false,
                            "show-file-list": false,
                            multiple: false,
                            accept: ".xlsx,.xls",
                            "on-change": _vm.handleUploadChange
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-upload" }),
                          _c("div", { staticClass: "el-upload__text" }, [
                            _vm._v("点击或拖拽到此处上传")
                          ]),
                          _c("div", { staticClass: "el-upload__tip" }, [
                            _vm._v("只支持 Excel 文件（.xlsx、.xls）")
                          ])
                        ]
                      ),
                      _vm.uploading
                        ? _c("div", { staticClass: "upload-result" }, [
                            _c("span", [_vm._v("正在上传...")])
                          ])
                        : _vm.form.fileName
                        ? _c(
                            "div",
                            { staticClass: "upload-result" },
                            [
                              _c("span", [
                                _vm._v("当前文件：" + _vm._s(_vm.form.fileName))
                              ]),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: { click: _vm.clearFile }
                                },
                                [_vm._v("移除")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          resize: "none",
                          placeholder: "请输入备注说明"
                        },
                        model: {
                          value: _vm.form.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "remark", $$v)
                          },
                          expression: "form.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 12 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-actions",
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "mini",
                            loading: _vm.submitting
                          },
                          on: { click: _vm.handleSubmit }
                        },
                        [_vm._v("提交创建")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", disabled: _vm.submitting },
                          on: {
                            click: function($event) {
                              return _vm.$emit("back")
                            }
                          }
                        },
                        [_vm._v("取消")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }